import { Navigate } from 'react-router-dom'
import { useAuth } from '@/hooks/useAuth'

/* Verhuisd — één canonieke profielpagina op /spelers/:id (Steam-model:
   iedereen ziet dezelfde secties, editknoppen alleen op eigen profiel).
   Instellingen wonen op /instellingen. Deze route blijft als redirect
   staan zodat oude links (header-dropdown, bookmarks) werken. */
export default function ProfilePage() {
  const { user } = useAuth()
  if (!user) return <Navigate to="/login" replace />
  return <Navigate to={`/spelers/${user.id}`} replace />
}
